import React from 'react';
import { connect } from 'react-redux';
import { 
    fetchTiposPublicacionAdm,
    setTiposPublicacion,
    setTiposGrupoPlanes 
} from '../../actions/tiposPublicacionActions';
import TipoPublicacionesListItem from './TipoPublicacionesListItem';
import Spinner from 'react-bootstrap/Spinner';
import ReactPaginate from 'react-paginate';
import FiltroTipoPublicaciones from './FiltroTipoPublicaciones';
import { setGrupoPlanes }from '../../actions/planesActions';
import { editando } from '../../actions/generalActios';

class ListTipoPublicaciones extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onFilter: false,
            hideLoader: false,
            hideNoHayTipos: false,
            cantidadPagina: 10,
            numeroPagina: 1
        }
    };

    componentDidMount() {
        this.busquedaTiposPublicacion({
            numeroPagina: this.state.numeroPagina,
            cantidadPagina: this.state.cantidadPagina
        });
    }

    busquedaTiposPublicacion = (request) => {
        this.props.fetchTiposPublicacionAdm(request);
    }

    componentWillReceiveProps(futureProps) {
        if(!this.state.hideLoader) this.setState({hideLoader: true});
        if(futureProps.tiposPublicaciones.length > 0 && this.state.hideNoHayTipos) {
            this.onTipoChange(futureProps.tiposPublicaciones.length);
        }
    }

    setFilter = (e) => {
        e.preventDefault();
        this.setState({onFilter: !this.state.onFilter});
    }
  
    handlePageClick = (e) => {
        this.setState({hideLoader: false});
        const selectedPage = e.selected + 1;
        this.busquedaTiposPublicacion({
            numeroPagina: selectedPage,
            cantidadPagina: this.state.cantidadPagina
        });
    };

    onTipoChange = (cantidadTipos) => {       
        if (cantidadTipos > 0) {
            this.setState({ hideNoHayTipos: true });
        } else {
            this.setState({ hideNoHayTipos: false });
        }
    }

    onTipo = (id, tipo) => {
        this.props.setTiposGrupoPlanes([]);
        this.props.setGrupoPlanes();
        this.props.setTiposPublicacion({ 
            id: id, 
            comision: tipo.comision, 
            descripcion: tipo.descripcion 
        });
        this.props.history.push(`/Tipo/Publicaciones/Editar/${id}`);
    }

    goToNuevo = () => {
        this.props.editando(false);
        this.props.setGrupoPlanes();
        this.props.history.push(`/Tipo/Publicaciones/Nuevo`);
    }

    onSubmit = async (event) => {
        event.preventDefault();
    }
    

    render() {
        let btnFilterText = this.state.onFilter ?  "Ocultar" : "Mostrar Filtro";
        let tiposPublicaciones =
            !Array.isArray(this.props.tiposPublicaciones) ? [] : this.props.tiposPublicaciones;

        return (
            <div>
                <div className="row align-items-center justify-content-between page-titles">

                    <div className="col-12 col-sm-6">
                        <h3 className="text-themecolor color-rojo-megatone">Tipo de Publicaciones</h3>
                    </div>

                    <div className="col-12 col-sm-6 mt-2 mt-sm-0 button-group text-end">

                        <button 
                            type="button" 
                            onClick={this.goToNuevo} 
                            className="btn btn-sm btn-green"
                        >
                            <i className="fa fa-plus-circle"/> Crear
                        </button>

                        <button 
                            type="button" 
                            className="btn btn-sm background-rojo-megatone" 
                            onClick={this.setFilter}
                        >
                            <i className="fa fa-filter"/> {btnFilterText}
                        </button>
                        
                    </div>
                </div>

                <div hidden={!this.state.onFilter}>
                    <FiltroTipoPublicaciones updateParams={this.busquedaTiposPublicacion}/>
                </div>

                <div hidden={!this.state.hideNoHayTipos}>
                    <h5 className="d-flex justify-content-center m-t-40 m-b-40">No hay publicaciones</h5>
                </div>
                
                <div hidden={this.state.hideLoader}>
                    <div className="d-flex justify-content-center">
                        <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                </div>

                <ul className="list-group">
                {
                    tiposPublicaciones.length > 0 ?

                    tiposPublicaciones.map((tipoPublicacion, index) => {
                        return (
                            <a 
                                key={index} 
                                onClick={() => {this.onTipo(tipoPublicacion.codigo, tipoPublicacion)}}
                            >
                                <TipoPublicacionesListItem
                                    codigo={tipoPublicacion.codigo}
                                    descripcion={tipoPublicacion.descripcion}
                                    comision={tipoPublicacion.comision}
                                /> 
                            </a>
                        );
                    })
                    : null
                }
                </ul>

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={this.props.cantidadTotal / this.state.cantidadPagina}
                        marginPagesDisplayed={10}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={0} 
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    seller: state.general.idSeller,
    tipoUsuario: state.general.tipoUsuario,
    tiposPublicaciones: state.tiposPublicacion.tiposPublicaciones.elementos,
    cantidadTotal: state.tiposPublicacion.tiposPublicaciones.cantidadTotal,
    numeroPagina: state.tiposPublicacion.tiposPublicaciones.numeroPagina,
});

export default connect(mapStateToProps, { 
    fetchTiposPublicacionAdm,
    setTiposGrupoPlanes,
    setTiposPublicacion,
    setGrupoPlanes,
    editando 
}) (ListTipoPublicaciones); 